@if (!isOneTimePay && !isOneTimeCard) {
  <div class="account-picker" [blocked]="isFlashPay" role="radiogroup" aria-label="Accounts on file">
    <section class="account-picker__section">
      <h3 class="account-picker__heading">
        Cards <span class="account-picker__count">{{ $cards().length }}</span>
      </h3>
      <div class="account-picker__grid">
        @for (item of $cards(); track item.method.id) {
          <app-account-card
            [item]="item"
            [selectable]="true"
            [selected]="isSelected(item.method)"
            [actions]="actionsFor(item.method)"
            (choose)="selectPaymentMethod($event)"
            (setDefault)="setDefaultPaymentMethod($event)"
            (action)="runAction($event, item.method)"
          />
        }
        <button type="button" class="account-card account-card--add" (click)="addCard.emit()">
          <mat-icon aria-hidden="true">add_card</mat-icon>
          add card
        </button>
      </div>
    </section>

    @if (achEnabled()) {
      <section class="account-picker__section">
        <h3 class="account-picker__heading">
          Bank accounts (ACH) <span class="account-picker__count">{{ $achAccounts().length }}</span>
        </h3>
        <div class="account-picker__grid">
          @for (item of $achAccounts(); track item.method.id) {
            <app-account-card
              [item]="item"
              [selectable]="true"
              [selected]="isSelected(item.method)"
              [actions]="actionsFor(item.method)"
              (choose)="selectPaymentMethod($event)"
              (setDefault)="setDefaultPaymentMethod($event)"
              (action)="runAction($event, item.method)"
            />
          }
          <button type="button" class="account-card account-card--add" (click)="addAchAccount.emit()">
            <mat-icon aria-hidden="true">account_balance</mat-icon>
            add ACH account
          </button>
        </div>
      </section>
    }
  </div>
}

@if (isOneTimePay) {
  <div class="app-payment-collect-stepper__content">
    <app-one-time-payment (formValidated)="selectOneTimePaymentMethod($event)" />
  </div>
}
@if (isOneTimeCard) {
  <div class="app-payment-collect-stepper__content">
    <app-one-time-payment
      [hideCustomerInfo]="true"
      [forceNoSave]="true"
      (formValidated)="selectOneTimePaymentMethod($event)" />
  </div>
}
